import React from "react"
import styled from "styled-components"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"

const TestimonialDiv = styled.div`
    position: relative;

    @media only screen and (max-width: 767px) {
        width: 80%;
        margin: auto;
    }
`
const WrapperDiv = styled.div`
    max-width: 1084px;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 76px 20px 80px;
    font-weight: 500;
    color: #6A7C92;
    border-top: 1px solid #979797;
    border-bottom: 1px solid #979797;
    margin-bottom: 160px;
    
    @media only screen and (max-width: 767px) {
        padding: 60px 15px 100px;
        margin-bottom: 100px;

        h2 {
            text-align: center;
        }
    }

    svg {
        margin-left: 20px;
    }

    > div {
        width: 100%;
    }

    .carousel.carousel-slider {
        overflow: initial;
    }

    .carousel .slide {
        width: 100%;
        background: #FFF;
    }

    .carousel.carousel-slider .control-arrow {
        width: 66px;
        height: 66px;
        background: none;
        opacity: 1;
        margin-top: 10px;

        @media only screen and (max-width: 920px) {
            display: none;
        }
    }

    .carousel.carousel-slider .control-next {
        background-image: url(/NextArrow.svg);
        background-repeat: no-repeat;

        &:before {
            border: none;
        }

        &:hover {
            background: none;
            background-image: url(/NextArrow-hover.svg);
        }
    }

    .carousel.carousel-slider .control-prev {
        background-image: url(/PrevArrow.svg);
        background-repeat: no-repeat;

        &:before {
            border: none;
        }

        &:hover {
            background: none;
            background-image: url(/PrevArrow-hover.svg);
        }
    }
`;

const TestimonialsSlideDiv = styled.div`
    text-align: center;
    width: 100%;
    max-width: 790px;
    margin: auto;
    cursor: drag;

    @media only screen and (max-width: 720px) {
        user-select: none;
    }
`;

const Details = () => (
    <>
    <TestimonialDiv>
        <WrapperDiv>
            <h2 className="margin-bottom-40">See what our customers say about us…</h2>
            <Carousel showThumbs={false} showIndicators={false} showArrows={true} showStatus={false} emulateTouch={true} autoPlay={true} interval={5000} infiniteLoop={true}>
            <TestimonialsSlideDiv>
                <p className="margin-bottom-10">“Before we moved to the Salesforce platform we had limited visibility into our business, customers and vendors. Implementing this system has revolutionized our understanding and allowed us to scale the business as quickly as we have. I couldn’t imagine trying to manage the growth we’ve experienced using our old disjointed systems”</p>
                <p className="testimonial-name margin-bottom-0"><strong>Joe Jones (CIO)</strong></p>
                <p className="testimonial-title">UpNorth Distribution</p>
            </TestimonialsSlideDiv>
            <TestimonialsSlideDiv>
                <p className="margin-bottom-10">"Moving 100% to the Salesforce platform has been a game changer for our business. We run multiple retail locations and self distribute all on the Salesforce platform. This solution has  let us consolidate purchasing to increase our buying power, and automated our compliance reporting to METRC which used to require duel data entry at every step"</p>
                <p className="testimonial-name margin-bottom-0"><strong>Bradley Ulisky</strong></p>
                <p className="testimonial-title">Libra Shop</p>
            </TestimonialsSlideDiv>
            </Carousel>
        </WrapperDiv>
    </TestimonialDiv>
    </>  
)

export default Details